import { useEffect, useState } from "react";
import { useCommonComponentContext } from "@maysoft/common-component-react";
import Strings from "../../../constants/strings";

const useLanguage = () => {
    const { language: currentLanguage } = useCommonComponentContext();

    const [language, setLanguage] = useState<string>(currentLanguage);

    useEffect(() => {
        Strings.setLanguage(currentLanguage);
        setLanguage(currentLanguage);
    }, [currentLanguage]);

    return {
        language,
        setLanguage,
    };
};

export default useLanguage;